import Vue from 'vue'
import Vuex from 'vuex'

// modules
import common from './modules/common'
import subject from './modules/subject'


Vue.use(Vuex)

// 开发的时候使用严格模式 (严格模式下，不允许在外部修改 store 的状态)
// @see http://vuex.vuejs.org/en/strict.html
const strict = (process.env.VUE_APP_BASE_URL !== 'prod')

export default new Vuex.Store({
    modules: {
        common,
        subject
    },
    strict
})



// WEBPACK FOOTER //
// ./src/store/index.js